











import { Component, Vue, Prop } from 'vue-property-decorator';
import IdentityData from '@/ts/IdentityData';

@Component({
    name: 'CorporationLogo',
})
export default class TenantDashboardButtons extends Vue {

    constructor() {
        super();
    }

    get selectedIdentity(): IdentityData {
        return this.$store.getters['Identities/getSelectedIdentity'];
    }
}
